import { createApiThunk } from "./thunkWrapper";



export const getUser = createApiThunk("user/getUser", (payload) => ({
  method: "GET",
  endPoint: "getUser", 
  params: {
    userId:localStorage.getItem("_id")
  },
}));
export const getExam = createApiThunk("user/getExam", (payload) => ({
  method: "GET",
  endPoint: "getExam", 
  params:payload,
}));

export const submitExam = createApiThunk("user/submitExam", (payload) => ({
  method: "POST",
  endPoint: "submitExam", 
  data:payload,
}));
export const createUser = createApiThunk("user/createUser", (payload) => ({
  method: "POST",
  endPoint: "createUser", 
  data:payload,
}));

